// Light / dark mode. The choice ("system", "light" or "dark") is a display
// preference, not finance data, so it lives in localStorage rather than the
// encrypted vault — that way the lock screen can be themed before unlocking.
const KEY = "nest-theme";
const STATUS_BAR = { light: "#EEF1FF", dark: "#0a2e36" };

const systemDark = window.matchMedia("(prefers-color-scheme: dark)");

export function getThemeChoice() {
  try {
    return localStorage.getItem(KEY) || "system";
  } catch {
    return "system";
  }
}

export function applyTheme(choice = getThemeChoice()) {
  const mode = choice === "dark" || (choice === "system" && systemDark.matches) ? "dark" : "light";
  document.documentElement.dataset.theme = mode;
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", STATUS_BAR[mode]);
}

export function setThemeChoice(choice) {
  try {
    localStorage.setItem(KEY, choice);
  } catch {}
  applyTheme(choice);
}

// Follow the phone switching between light and dark (e.g. automatic at sunset).
systemDark.addEventListener("change", () => applyTheme());
